<template>
  <div class="mainBox">
    <router-link to="/" style="text-decoration: none; float: left">
      <div class="el-page-header__left" style="width: 60px">
        <i class="el-icon-back"></i>
        <div class="el-page-header__title">返回</div>
      </div>
      <!-- <el-page-header @back="goBack" content="详情页面"> </el-page-header> -->
    </router-link>
    <span
      class="el-page-header__content"
      style="
        top: -0px;
        position: relative;
        font-size: 14px;
        color: rgb(96, 98, 102);
      "
      >列表页</span
    >
    <br />
    <el-alert :title="paper.tip" type="warning"> </el-alert>
    <br />
    <div style="text-align: center">
      <el-button
        v-if="showTypeIn"
        @click="submit(null)"
        type="primary"
        icon="el-icon-edit"
        round
        style="width: 300px"
        >填写新表</el-button
      >
    </div>
    <br/>
     <el-divider content-position="center">以下是往期填报数据</el-divider>
    <el-form
      label-width="100px"
      style="display: block !important; width: 100% !important"
    >
      <el-row :gutter="24">
        <el-col
          v-for="(item, index) in record"
          v-bind:key="index"
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
        >
          <br />
          <!-- <router-link :to="'/pageOne?id='+item.recordId+'&pid='+item.paperId" style="text-decoration: none;"> -->
          <!-- 数据记录 -->
          <el-card
            class="box-card"
            style="cursor: pointer"
            @click.native="toDetail(item)"
          >
          <!-- 表头 -->
            <div slot="header" class="clearfix">
              <span>填报编号：{{ item.recordId }}</span>
              <span style="float: right; margin-top: 4px;">
                {{ "[" + (item.fillDate || item.createTime) + "]" }}</span
              >
              <el-badge
                :type="item.isConfirm ? 'success' : 'info'"
                :value="item.isConfirm ? '√' : '√'"
                style="display: block; top: 3px; left: -4px; float: left"
              >
              </el-badge>
            </div>

            <!-- 表体 -->
            <div
              v-for="(item2, index) in paperItem"
              v-bind:key="index"
              class="text item"
            >
            
              <div v-if="item2.itemShow == true">
               
                <span class="paperItemTitle">{{ item2.itemTitle + ":" }}</span>
                <div class="paperItemValue">
                  &nbsp;{{ item[item2.itemStore] }}
                </div>
              </div>
            </div>

            <div
              v-if="paper.isDaily == true"
              style="text-align: left; margin-top: 8px"
            >
              <!--每日tag -->
              <el-tag
                @click.stop="showDetail(item3.recordId)"
                class="paperDailyBox"
                v-for="(item3,index) in item.dailyItems"
                v-bind:key="index"
                :type="item3.isConfirm?'success':'info'"
                >{{ item3.itemDate }}</el-tag
              >
              <!-- <el-button v-for="i in diffdate" v-bind:key="i" type="success" style="width:30px;height:30px;" circle> {{i}}</el-button> -->
              <span
                style="
                  width: auto;
                  text-align: center;
                  display: inline-block;
                  float: right;
                "
              >
                <el-button
                  @click.stop="submit(item)"
                  size="small"
                  type="primary"
                  icon="el-icon-edit"
                  round
                  class="paperTypeInToday"
                  >填写今日</el-button
                >
              </span>
            </div>
          </el-card>

          <!-- </router-link> -->
        </el-col>
      </el-row>
    </el-form>
    <br />
    <!-- 分页 -->
    <div style="text-align: center">
      <!-- <el-pagination
        background
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :current-page.sync="this.pageNum"
        :pager-count='5'
        :page-count.sync="this.pageNum"
        :page-size="this.pageSize"
        :total="this.pageTotal"
        @current-change="handleCurrentChange"
      >
      </el-pagination> -->
       <pagination :total="pageTotal" 
                  :page.sync="pageNum" 
                  :pager-count='5'
                  :limit.sync="pageSize"
		              @pagination="handleCurrentChange" 
                  style="padding:6px;"/>
    </div>
    <br />
    <br />
    <br />

    <!-- 弹窗 -->
    <el-dialog
      title="填写内容："
      :visible.sync="dialogVisible"
      width="90%"
      style="max-width: 530px; margin: auto"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form style="display: block !important; width: 100% !important">
        <el-row :gutter="0">
          <el-alert :title="paper.title" type="success" :closable="false">
          </el-alert>
        </el-row>
        <el-row
          :gutter="0"
          v-for="(item, index) in tempItems"
          v-bind:key="index"
        >
          <el-form-item :label="item.itemTitle + '：'">
            <el-input @click.native="item.inputType=='select'?openChoose(item,$event):null"
              v-model="item['userAnswer']"
              :placeholder="item.placeholder"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

       <!-- 弹窗 -->
    <el-dialog
      title="请选择:"
      :visible.sync="dialogSelectVisible"
      width="90%"
      style="max-width:530px;margin:auto;"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form style="display: block !important;width: 100%!important;overflow:auto;">
         <span  style="dispaly:block;overflow:auto;"
        
         v-for="(item, index) in selectList.list" v-bind:key="index" 
      >
        <!-- <el-alert v-if="index==0" :title="item.groupTitle" type="success"  :closable="false"> </el-alert> -->
        <!-- <el-form-item :label="item.itemTitle+'：'">
          <el-input v-model="item.userAnswer" :placeholder="item.placeholder" clearable="true"></el-input>
        </el-form-item> -->
        <div @click="choose(selectList,item)" > 【{{item}}】</div>
         </span>
      </el-form>
      <br/>
       <br/>
        <br/>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitItems"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading } from "element-ui";
import { createTable, from, Filter, dateChange } from "@/api/jsDb/dbms.js";
var jsdb;

import {
  Get_Paper,
  Get_Paper_preItem,
  Get_Paper_dailyItem,
  Put_Paper_PreItem,
  Put_Paper_DailyItem,
  Get_Paper_RecordList,
  Get_Paper_notDailyItem,
  Get_Paper_RecordDailys,
} from "@/api/pageOne/ApiIndex.js";
export default {
  data() {
    return {
      activeNames: ["1"],
      dialogVisible: false,
      dialogVisible_daily: false,
      paperId: "",
      paper: [],
      paperItem: [],
      paperDailyItems: [],
      tempItems: [],
      paperTitle: "",
      record: [],
      recordId: "-1",
      diffdate: 0,
      pageNum: 1,
      pageSize: 6,
      pageTotal: 0,
      dialogSelectVisible:false,
      selectList:{},
      showTypeIn:true,
    };
  },
   //2.3.2、监听区
    watch:{
      //监听页面参数变化时，将页面存储参数更新
      "pageNum":function(){this.setParams()},
    },
  created() {
    let loadingInstance = Loading.service({ fullscreen: true });
    this.paperId = this.$route.query["id"].toString();
    this.getParams();

    if(this.paperId=="") this.showTypeIn = false;
   

    Get_Paper_preItem({ paperId: this.paperId }).then((response) => {
      this.paperItem = response.data.data;
    });
    // Get_Paper_dailyItem({ paperId: this.paperId }).then((response) => {
    //   this.paperDailyItems = response.data.data;
    // });
    Get_Paper({ paperId: this.paperId }).then((response) => {
      this.paper = response.data.data[0];
      // console.log("---");
      // console.log(response);
      this.paperTitle = this.paper.title;
    });

    Get_Paper_RecordList({ paperId: this.paperId }).then((response) => {
      jsdb = from(response.data.data);
      let jsQuery = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      
      Get_Paper_RecordDailys({}).then(response =>{
            jsdb.select().forEach(item=>{
              item.dailyItems = from(response.data.data).where("parentId","=",item.recordId).select();
            })
      let rezlut = jsdb.page(jsQuery);
      this.record = rezlut.rows;
      this.pageTotal = rezlut.total;
       console.log(this.pageNum)
    })

      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      });
    });

    this.diffdate = this.getDiffDate();
  },
  methods: {
    setParams(){
        let pageParams = {
          pageNum:this.pageNum,
        }
        //console.log("set:"+pageParams)
        Vue.prototype.setPageParams(this.$route.path+this.paperId,pageParams);
      },
      getParams(){
        var pageParams = Vue.prototype.getPageParams(this.$route.path+this.paperId);
        if(pageParams!=null){
          this.pageNum = pageParams.pageNum;
          //this.handleCurrentChange(this.pageNum);
          console.log("get" + this.pageNum)
        }
      },
    //回退，未用
    goBack() {
      console.log("go back");
    },
    //未用
    handleChange(val) {
      console.log(val);
    },
    //关闭弹窗
    handleClose(done) {
      done();
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
    },
    //未用，点击后，准备输入弹窗
    typeIn(itemId) {
      this.dialogVisible = true;
      this.recordId = "-1";
      this.tempItems = this.paperItem;
      this.paperItem.forEach(item =>{
        if(item.itemStore=="title"){
          item.userAnswer = this.paper.title
          //+"_"+sessionStorage.getItem("username")+"_"+new Date().getMonth()+1+"_"+new Date().getDate();
        }
      })
    },
    //未用，点击后，准备输入每日填报
    typeInDaily(item) {
      let hasItem = 0
      item.dailyItems.forEach(item2 =>{
        if(item2.itemDate == new Date().getDate()){
          ++hasItem
        }
        //  console.log(item2)
        // console.log(item2.itemDate  +":" +new Date().getDate())
      })
      if(hasItem>0){
        this.$alert("今天已填写，不能再提交！", "错误信息", { type: "error" });
        return;
      }
      this.dialogVisible = true;
      if (this.recordId != item.recordId) {
        this.recordId = item.recordId;
        this.paperDailyItems.forEach((item) => {
          item.userAnswer = "";
        });
      }

      this.tempItems = this.paperDailyItems;
    },
    //弹窗判断和提交
    submit(item) {
      if (item==null) {
        let query = {
        paperId: this.paper.paperId,
        isDaily:this.paper.isDaily,
        title:this.paper.title,
        };
        Put_Paper_PreItem(query).then((response) => {
          if (response.data.code != 20000) {
            this.$alert(response.data.message, "错误信息", { type: "error" });
            this.dialogVisible = false;
            return;
          }
          this.$message({message: "已生成，请填写！",type: "success"});
          this.$router.push({
            path:
              "/pageOne?id=" +
              response.data.data[0].recordId +
              "&pid=" +
              response.data.data[0].paperId,
          }); //到定向页或者主页
        });
      } else {
        let hasItem = 0
          item.dailyItems.forEach(item2 =>{
            if(item2.itemDate == new Date().getDate()){
              ++hasItem
            }
          })
          if(hasItem>0){
            this.$alert("今天已填写，不能再提交！", "错误信息", { type: "error" });
            return;
          }

        let lastItems = [];
        let tempRecord = from(this.record)
          .where("recordId", "=", item.recordId)
          .select(0);
        Get_Paper_notDailyItem({ paperId: this.paper.paperId }).then((response) => {
          if (response.data.code == 20000) {
            lastItems = response.data.data;
            lastItems.forEach((item) => {
              item.userAnswer = tempRecord[item.itemStore];
            });

            lastItems = lastItems.concat(this.tempItems);
            let query = {
              recordId: item.recordId,
              title:this.paper.title,
              data: lastItems,
            };

            // console.log(lastItems);
            Put_Paper_DailyItem(query).then((response) => {
              if (response.data.code != 20000) {
                this.$alert(response.data.message, "错误信息", {
                  type: "error",
                });
                this.dialogVisible = false;
                return;
              }
              this.$message({message: "已生成，请填写！",type: "success"});
              this.$router.push({
                path:
                  "/pageOne?id=" +
                  response.data.data[0].recordId +
                  "&pid=" +
                  response.data.data[0].paperId,
              });
            });
          }
        });
      }
    },
    //去查看每日数据
    toDetail(item) {
      this.$router.push({
        path: "/pageOne?id=" + item.recordId + "&pid=" + item.paperId,
      });
    },
    //去查看主记录数据
    showDetail(recordId){
      this.$router.push({
              path: "/pageOne?id=" + recordId + "&pid=" + this.paperId,
            });
    },
    //改变页号
    handleCurrentChange(index) {
      //this.pageNum = index;
      let jsQuery = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      let rezlut = jsdb.page(jsQuery);
      this.record = rezlut.rows;
      this.pageTotal = rezlut.total;
    },
    //判断日期差，未用
    getDiffDate() {
      let date1 = new Date();
      let date2 = new Date();
      date1 = new Date(
        date1.getFullYear(),
        date1.getMonth() - 1,
        1 // date1.getDate()
      );
      date2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        1 //date2.getDate()
      );
      const diff = date2.getTime() - date1.getTime();
      const diffDate = diff / (24 * 60 * 60 * 1000);
      return diffDate;
    },
    openChoose(item,event){
      event.srcElement.blur();
      var list = item.selectList.split(",");
      this.selectList = {
        item:item,
        list:list,
      }
      this.dialogSelectVisible = true;
    },
    choose(selectList,item){
      selectList.item.userAnswer = item;
      this.dialogSelectVisible = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//<!--3.1、样式区-->
<style type="text/css" scoped>
.mainBox {
  max-width: 900px;
  margin: 0px auto 10px auto;
  background-color: #fffdf7;
  border-style: dotted;
  border-width: thin;
  padding: 10px 10px;
  border-color: gainsboro;
  border-radius: 10px;
}
.el-message-box {
  max-width: 130px !important;
  width: 300px !important;
}
.paperItemValue {
  word-break: break-all;
  font-size: 14px;
  /* color: rgb(29, 162, 69); */
  color:#f56c6c;
  border-color: rgb(235, 238, 245);
  border-radius: 6px;
  /* border-style: solid; */
  padding: 7px;
  min-height: 20px;
  border-width: 1px;
  background-color: #fbfbfb;
}
.paperItemTitle {
  /* font-weight: bold; */
  font-size: 14px;
  color: rgb(96, 98, 102);
  padding: 4px 0px;
  display: inline-block;
}
.paperDailyBox {
  width: 34px;
  height: 32px;
  margin: 0px 4px 8px 4px;
  text-align: center;
}
.paperTypeInToday {
  width: auto;
  text-align: center;
  float: right;
  margin-bottom: 30px;
}
.el-badge__content.is-fixed {
  top: 90px !important;
  right: 58px !important;
}
/**控制本页边界 */
.el-form-item {
  margin-bottom: 10px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.el-divider--horizontal {
  margin: 10px 0 !important;
}
.el-dialog__body {
  padding: 0px 20px 20px 20px !important;
}
/**解决form无高度问题 */
.el-form {
  display: inline-block !important;
}
.el-table--mini th,
.el-table--mini td {
  padding: 0px !important;
}
.el-table--small th,
.el-table--small td {
  padding: 4px !important;
}
.el-table .cell {
  line-height: 16px !important;
}
.el-divider--horizontal {
  margin: 12px 0px !important;
}
.el-card {
  border-radius: 16px !important;
  /* //background-color: #fdfbf8 !important; */
  box-shadow: 1px 1px 2px #888888;
}
.el-dialog {
  border-radius: 16px !important;
}
.light:hover {
  color: red !important;
}
.el-badge__content.is-fixed {
  z-index: 20 !important;
}
</style>
<style type="text/css">
.el-dialog {
  border-radius: 12px !important;
}
.el-message-box {
  max-width: 330px !important;
  /* width:300px !important; */
}
.el-pagination {
    padding: 0px  !important;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    margin: 0 2px !important;
}
</style>


// WEBPACK FOOTER //
// src/api/pageOne/pageOneList.vue